import React, { useEffect, useState } from "react";
import { Alert, Button, Container, Form, Modal, Table } from "react-bootstrap";
import { authFetch } from "../utils/authFetch";

export default function Angajati() {
  const [items, setItems] = useState([]);
  const [editor, setEditor] = useState(null);
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);
  const [revision, setRevision] = useState(0);
  const [query, setQuery] = useState("");
  useEffect(() => {
    let active = true;
    authFetch("/angajati/?include_inactive=true").then(data => { if (active) setItems(data); })
      .catch(err => { if (active) setError(err.message); });
    return () => { active = false; };
  }, [revision]);
  const save = async event => {
    event.preventDefault(); setSaving(true); setError("");
    try {
      await authFetch(`/angajati/${editor.id || ""}`, { method: editor.id ? "PUT" : "POST",
        body: JSON.stringify({ nume_prenume: editor.nume_prenume.trim(), marca: editor.marca?.trim() || null, activ: editor.activ, coeficient: Number(editor.coeficient) }) });
      setEditor(null); setRevision(value => value + 1);
    } catch (err) { setError(err.message); }
    finally { setSaving(false); }
  };
  return <Container className="py-4">
    <div className="d-flex justify-content-between mb-3"><h3>Angajați</h3>
      <Button onClick={() => setEditor({ nume_prenume: "", marca: "", activ: true, coeficient: 1 })}>Adaugă angajat</Button></div>
    <p>Angajații pot fi repartizați pe operațiile de manoperă. Dezactivarea păstrează istoricul lucrărilor.</p>
    {error && !editor && <Alert variant="danger">{error}</Alert>}
    <Form.Control aria-label="Caută angajat" placeholder="Caută după nume sau marcă" value={query} onChange={e => setQuery(e.target.value)} className="mb-3" />
    <Table bordered hover><thead><tr><th>Nume și prenume</th><th>Marcă</th><th>Coeficient</th><th>Stare</th><th /></tr></thead>
      <tbody>{items.filter(item => `${item.nume_prenume} ${item.marca || ""}`.toLocaleLowerCase().includes(query.toLocaleLowerCase())).map(item =>
        <tr key={item.id}><td>{item.nume_prenume}</td><td>{item.marca}</td><td>{Number(item.coeficient)}</td><td>{item.activ ? "Activ" : "Inactiv"}</td>
          <td><Button size="sm" onClick={() => setEditor({ ...item, marca: item.marca || "", activ: !!item.activ })}>Editează</Button></td></tr>)}</tbody></Table>
    <Modal show={!!editor} onHide={() => !saving && setEditor(null)} centered>
      <Modal.Header closeButton={!saving}><Modal.Title>{editor?.id ? "Editează angajat" : "Adaugă angajat"}</Modal.Title></Modal.Header>
      {editor && <Form onSubmit={save}><Modal.Body>
        {error && <Alert variant="danger">{error}</Alert>}
        <Form.Group controlId="angajat-nume" className="mb-3"><Form.Label>Nume și prenume</Form.Label>
          <Form.Control required maxLength={100} value={editor.nume_prenume} onChange={e => setEditor({ ...editor, nume_prenume: e.target.value })} /></Form.Group>
        <Form.Group controlId="angajat-marca" className="mb-3"><Form.Label>Marcă</Form.Label>
          <Form.Control maxLength={50} value={editor.marca} onChange={e => setEditor({ ...editor, marca: e.target.value })} /></Form.Group>
        <Form.Group controlId="angajat-coeficient" className="mb-3"><Form.Label>Coeficient repartizare manoperă</Form.Label><Form.Control type="number" min="0.0001" step="0.0001" required value={editor.coeficient} onChange={e => setEditor({ ...editor, coeficient: e.target.value })} /><Form.Text>Exemplu: 1 standard; 1,2 specialist. Modificarea se aplică repartizărilor noi.</Form.Text></Form.Group>
        <Form.Check label="Activ" checked={editor.activ} onChange={e => setEditor({ ...editor, activ: e.target.checked })} />
      </Modal.Body><Modal.Footer><Button type="submit" disabled={saving}>{saving ? "Se salvează…" : "Salvează"}</Button></Modal.Footer></Form>}
    </Modal>
  </Container>;
}
